export const SINGLE_PAYMENT_LINKS_EVENTS = {
  PAYMENT_LINK_PAGE_VIEWED: 'Payment Link Create Page Viewed',
  PAYMENT_METHODS_MODAL_OPEN: 'Payment Link Payment Methods Modal Opened',
  CUSTOMER_MODE_SELECTED: 'Payment Link Customer Mode Selected',
  CUSTOMER_DETAILS_TOGGLE_CHANGED:
    'Payment Link Customer Details Toggle Changed',
  CUSTOMER_ADDED: 'Payment Link Customer Added',
  CUSTOMER_EDITED: 'Payment Link Customer Edited',
  RESTRICTIONS_UPDATED: 'Payment Link Restrictions Updated',
  ADVANCED_OPTIONS_EXPANDED: 'Payment Link Advanced Options Expanded',
  PRODUCT_IMAGE_UPDATED: 'Payment Link Product Image Updated',
  PRODUCT_DESCRIPTION_UPDATED: 'Payment Link Description Updated',
  REFERENCE_ID_UPDATED: 'Payment Link Reference ID Updated',
  PREVIEW_TOGGLED: 'Payment Link Preview Toggled',
  CUSTOMIZE_CHECKOUT_CLICKED: 'Payment Link Customize Checkout Clicked',
  CREATE_CLICKED: 'Payment Link Create Clicked',
  PAYMENT_LINK_CREATED: 'Payment Link Created',
  PAYMENT_LINK_CREATION_FAILED: 'Payment Link Create Failed',
  SHARE_MODAL_VIEWED: 'Payment Link Share Modal Viewed',
  LINK_COPIED: 'Payment Link Link Copied',
  LINK_SHARED: 'Payment Link Shared',
  QR_CODE_VIEWED: 'Payment Link QR Code Viewed',
  QR_CODE_COPIED: 'Payment Link QR Code Copied',
  QR_CODE_PRINTED: 'Payment Link QR Code Printed',
};

export const SINGLE_PAYMENT_LINKS_EVENTS_PARAMS = {
  CUSTOMER_MODE: 'customer_mode',
  ALLOW_CUSTOMER_INPUT: 'allow_customer_input',
  HAS_EMAIL: 'has_email',
  HAS_PHONE: 'has_phone',
  HAS_FULL_NAME: 'has_full_name',
  UNLIMITED_PAYMENTS: 'unlimited_payments',
  MAX_PAYMENTS: 'max_payments',
  NO_EXP_DATE: 'no_expiration_date',
  EXP_DATE_TIME: 'expiration_datetime',
  SECTION: 'section',
  ACTION: 'action',
  DESC_LENGTH: 'description_length',
  REF_ID_LENGTH: 'reference_id_length',
  PREVIEW_VISIBLE: 'preview_visible',
  SOURCE: 'source',
  LINK_ID: 'link_id',
  ERR_FIELD: 'error_field',
  COPY_TARGET: 'copy_target',
  RECIPIENTS_COUNT: 'recipients_count',
  RECIPIENT_TYPES: 'recipient_types',
  DELIVERY_CHANNEL: 'delivery_channel',
  EGYPT_ONLY_SMS_CONSTRAINT: 'egypt_only_sms_constraint',
};

export const SINGLE_PAYMENT_LINKS_EVENTS_VALUES = {
  ADVANCED_OPTIONS: 'advanced_options',
  ADDED: 'added',
  REPLACED: 'replaced',
  REMOVED: 'removed',
  VALIDATION_ERROR: 'validation_error',
  API_ERROR: 'api_error',
  PAYMENT_LINK_QR_MODAL: 'payment_link_qr_modal',
  QR_CODE_IMG: 'qr_code_image',
  PAYMENT_LINK_SHARE_MODAL: 'payment_link_share_modal',
};
